import { Link } from "react-router-dom";
import "./style/Bottombar.css";

const Bottombar = () => {




  return (

    <>

     
        <div className="bottombar-container">
          <ul className="bottombar-nav">
            <li className="nav-item">
              <Link to="/" className="nav-link">
                <span className="nav-icon">🏠</span>
                <span className="nav-text">Home</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/bookmarked-questions" className="nav-link">
                <span className="nav-icon">⭐</span>
                <span className="nav-text">Saved Ques..</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/bookmarked-pdfs" className="nav-link">
                <span className="nav-icon">📑</span>
                <span className="nav-text">Saved Pdf</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/profile" className="nav-link">
                <span className="nav-icon">👤</span>
                <span className="nav-text">Profile</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/more-options" className="nav-link">
                <span className="nav-icon">☰</span>
                <span className="nav-text">More</span>
              </Link>
            </li>
          </ul>
        </div>
     

    </>

  );
};

export default Bottombar;